<ng-template [ngTemplateOutlet]="templateElement" [ngTemplateOutletContext]="{ $implicit: belastungMaster }"></ng-template>

<ng-template #typ00>
  <span [capHistinfo]="belastungMaster.histInfo">
    <cap-kompakt-grundstueck [item]="belastungMaster.grundstueck" format="GRUNDSTUECK_TYP00"></cap-kompakt-grundstueck>
  </span>
  <ng-temmplate [ngTemplateOutlet]="typ01"></ng-temmplate>
</ng-template>

<ng-template #typ01>
  <ng-container>
    {{ belastung.pfandstelle }}. <span>{{"Pfandstelle" | translate}}</span>, ({{ belastung.rangbestimmendesDatum | datum }}
    <span
      ><cap-kompakt-beleg
        [item]="belastung.beleg"
        [referenzObjectId]="belastung.id.id"
        [referenzObjectType]="'PFANDRECHT'"></cap-kompakt-beleg
      >)</span
    >
    @if (belastung.teilpfandgruppe) {
      <span
        >, {{ "TeilbetragGruppe" | translate }} {{ belastung.teilpfandgruppe.bezeichnung }}:
        {{ belastung.teilpfandgruppe.teilbetrag | betrag: true }}</span
      >
    }
    @if (belastung.nachrueckungsrecht && !belastung.codeNachrueckungsArt) {
      <span>, {{ "Nachrückungsrecht" | translate }}</span>
    }
    @if (belastung.nachrueckungsrecht && belastung.codeNachrueckungsArt) {
      <span
        >, {{ "Vormerkung" | translate }}: {{ "Nachrückungsrecht" | translate }}
        {{ belastung.codeNachrueckungsArt?.text | translateName }}</span
      >
    }
  </ng-container>
</ng-template>
